import React from 'react';
import { SearchIcon, DownloadIcon, FilterIcon, EyeIcon } from 'lucide-react';
const MOCK_DATA = Array.from({
  length: 10
}).map((_, i) => ({
  id: `REC-10${42 - i}`,
  date: i < 3 ? 'Hoy' : 'Ayer',
  time: `${10 - i % 4}:${15 + i * 5} AM`,
  area: ['Emergencia', 'UCI', 'Quirófano', 'Pediatría', 'Maternidad'][i % 5],
  user: ['Juan Pérez', 'María Gómez', 'Carlos Ruiz'][i % 3],
  total: Math.floor(Math.random() * 50) + 20,
  status: 'Sincronizado'
}));
export function CollectionsTable() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col h-full" data-id="element-388">
      {/* Toolbar */}
      <div className="p-4 border-b border-gray-200 flex flex-wrap gap-4 items-center justify-between bg-gray-50 rounded-t-xl" data-id="element-389">
        <div className="flex flex-wrap gap-3 flex-1" data-id="element-390">
          <div className="relative w-64" data-id="element-391">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-392">
              <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-393" />
            </div>
            <input type="text" placeholder="Buscar por ID o área..." className="block w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:outline-none" style={{
            focusRingColor: '#3d99d2'
          }} data-id="element-394" />
          </div>

          <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-white focus:outline-none" data-id="element-395">
            <option data-id="element-396">Todas las áreas</option>
            <option data-id="element-397">Emergencia</option>
            <option data-id="element-398">UCI</option>
            <option data-id="element-399">Quirófano</option>
          </select>

          <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-white focus:outline-none" data-id="element-400">
            <option data-id="element-401">Todos los recolectores</option>
            <option data-id="element-402">Juan Pérez</option>
            <option data-id="element-403">María Gómez</option>
          </select>

          <button className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white hover:bg-gray-50" data-id="element-404">
            <FilterIcon className="w-4 h-4" data-id="element-405" />
            Más filtros
          </button>
        </div>

        <div className="flex gap-2" data-id="element-406">
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors" data-id="element-407">
            <DownloadIcon className="w-4 h-4" data-id="element-408" />
            Excel
          </button>
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white shadow-sm hover:opacity-90 transition-colors" style={{
          backgroundColor: '#134073'
        }} data-id="element-409">
            <DownloadIcon className="w-4 h-4" data-id="element-410" />
            PDF
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="flex-1 overflow-auto" data-id="element-411">
        <table className="w-full text-left border-collapse" data-id="element-412">
          <thead className="sticky top-0 bg-white shadow-sm z-10" data-id="element-413">
            <tr className="text-gray-500 text-sm border-b border-gray-200" data-id="element-414">
              <th className="px-6 py-4 font-medium" data-id="element-415">ID</th>
              <th className="px-6 py-4 font-medium" data-id="element-416">Fecha</th>
              <th className="px-6 py-4 font-medium" data-id="element-417">Hora</th>
              <th className="px-6 py-4 font-medium" data-id="element-418">Área</th>
              <th className="px-6 py-4 font-medium" data-id="element-419">Recolector</th>
              <th className="px-6 py-4 font-medium" data-id="element-420">Total Prendas</th>
              <th className="px-6 py-4 font-medium" data-id="element-421">Estado</th>
              <th className="px-6 py-4 font-medium text-right" data-id="element-422">Acciones</th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-423">
            {MOCK_DATA.map((row, i) => <tr key={i} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-424">
                <td className="px-6 py-4 font-bold text-gray-900" data-id="element-425">{row.id}</td>
                <td className="px-6 py-4 text-gray-600" data-id="element-426">{row.date}</td>
                <td className="px-6 py-4 text-gray-600" data-id="element-427">{row.time}</td>
                <td className="px-6 py-4 font-medium text-gray-900" data-id="element-428">
                  {row.area}
                </td>
                <td className="px-6 py-4 text-gray-600" data-id="element-429">{row.user}</td>
                <td className="px-6 py-4 font-bold text-lg" style={{
              color: '#134073'
            }} data-id="element-430">
                  {row.total}
                </td>
                <td className="px-6 py-4" data-id="element-431">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-432">
                    {row.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-right" data-id="element-433">
                  <button className="p-2 rounded-lg hover:bg-blue-50 transition-colors inline-flex" style={{
                color: '#3d99d2'
              }} title="Ver detalle" data-id="element-434">
                    <EyeIcon className="w-5 h-5" data-id="element-435" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="p-4 border-t border-gray-200 flex items-center justify-between bg-white rounded-b-xl" data-id="element-436">
        <span className="text-sm text-gray-500" data-id="element-437">
          Mostrando 1 a 10 de 145 registros
        </span>
        <div className="flex gap-1" data-id="element-438">
          <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 disabled:opacity-50" disabled data-id="element-439">
            Anterior
          </button>
          <button className="px-3 py-1 border border-gray-300 rounded text-sm text-white font-medium" style={{
          backgroundColor: '#134073'
        }} data-id="element-440">
            1
          </button>
          <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-441">
            2
          </button>
          <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-442">
            3
          </button>
          <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-443">
            Siguiente
          </button>
        </div>
      </div>
    </div>;
}